export default __webpack_public_path__ + "static/media/STLCover-LetterMonitoringagencyreport.84583e5b.pdf";